import { useCallback } from "react";
import { useEffect, useState } from "react";

function SortTable2(arrData, key, isSortedAtoZ, pushObj) {
  const [keyForOrdering, setKeyForOrdering] = useState(key);
  const [isAscending, setIsAscending] = useState(isSortedAtoZ);

  const handleOrdering = (key, condition) => {
    setKeyForOrdering(key);
    condition !== undefined
      ? setIsAscending(condition)
      : setIsAscending((prevState) => !prevState);
  };

  const sortingFun = useCallback(() => {
    for (let i = arrData?.length; i > 0; i--) {
      for (let j = 0; j < i; j++) {
        let valueToCheck = "";
        let nextValueToCheck = "";
        if (keyForOrdering?.key2 === undefined) {
          valueToCheck = arrData?.[j]?.[keyForOrdering.key1];
          nextValueToCheck = arrData?.[j + 1]?.[keyForOrdering.key1];
        } else if (keyForOrdering?.key3 === undefined) {
          valueToCheck =
            arrData?.[j]?.[keyForOrdering.key1]?.[keyForOrdering.key2];
          nextValueToCheck =
            arrData?.[j + 1]?.[keyForOrdering.key1]?.[keyForOrdering.key2];
        } else {
          valueToCheck =
            arrData?.[j]?.[keyForOrdering.key1]?.[keyForOrdering.key2]?.[
              keyForOrdering.key3
            ];
          nextValueToCheck =
            arrData?.[j + 1]?.[keyForOrdering.key1]?.[keyForOrdering.key2]?.[
              keyForOrdering.key3
            ];
        }
        let tempValueToCheck = valueToCheck;

        if (
          isNaN(Number(tempValueToCheck?.replaceAll("-", ""))) &&
          isNaN(tempValueToCheck?.replaceAll(",", ""))
        ) {
          for (let k = 0; k < valueToCheck?.length; k++) {
            let a = valueToCheck?.charCodeAt(k);
            let b = nextValueToCheck?.charCodeAt(k);
            let temp = null;

            if (a > b && a - b !== 32) {
              temp = arrData?.[j];
              arrData[j] = arrData?.[j + 1];
              arrData[j + 1] = temp;
              break;
            } else if (a < b && a - b !== 32) {
              break;
            }
          }
        } else if (
          valueToCheck?.includes(".") ||
          valueToCheck?.includes(",") ||
          !isNaN(valueToCheck) ||
          (valueToCheck?.includes("-") && valueToCheck?.indexOf("-") === 0)
        ) {
          let temp = null;
          let firstValue = valueToCheck?.replaceAll(",", "");
          let secondValue = nextValueToCheck?.replaceAll(",", "");
          if (Number(firstValue) > Number(secondValue)) {
            temp = arrData?.[j];
            arrData[j] = arrData?.[j + 1];
            arrData[j + 1] = temp;
          }
        } else {
          let temp = null;
          if (
            Number(valueToCheck?.replaceAll("-", "")) >
            Number(nextValueToCheck?.replaceAll("-", ""))
          ) {
            temp = arrData?.[j];
            arrData[j] = arrData?.[j + 1];
            arrData[j + 1] = temp;
          }
        }
      }
    }
  }, [keyForOrdering, arrData]);

  useEffect(() => {
    sortingFun();
  }, [sortingFun]);

  return {
    isAscending: isAscending,
    key1:
      keyForOrdering.key2 !== undefined && keyForOrdering.key2 === "xirr"
        ? "xirr"
        : keyForOrdering.key1,
    arrData: isAscending ? arrData : arrData?.slice()?.reverse(),
    setKeyForOrdering: (key, condition) => handleOrdering(key, condition),
  };
}

export default SortTable2;
